function ApplicationItemVO(name, cssClass, url) {

    this.name = name;
    this.cssClass = cssClass;
    this.url = url;

    var _typeContext = {
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    }
}
